import {DatePicker as ArkDatePicker} from '@ark-ui/react/date-picker'
import './index.less'

export const DatePickerControl = ArkDatePicker.Control
